// extracted by mini-css-extract-plugin
export default {"highlight":"nBRH_0","countImageWrapper":"r3sVIa","countImage":"jhvINQ","mostPopularLabel":"_Fhv1M","oldPrice":"jq3w4K"};